import { useState } from 'react';
import SEOHead from '../../components/SEOHead';

export default function Salons() {
  const [selectedRegion, setSelectedRegion] = useState('全国');
  const [searchTerm, setSearchTerm] = useState('');
  const [showAffiliateForm, setShowAffiliateForm] = useState(false);
  const [affiliateFormData, setAffiliateFormData] = useState({
    salon_name: '',
    representative_name: '',
    email: '',
    phone: '',
    address: '',
    experience_years: '',
    staff_count: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const regions = ['全国', '北海道・東北', '関東', '中部', '関西', '中国・四国', '九州・沖縄'];

  const salons = [
    {
      id: 1,
      name: 'toiro',
      region: '関東',
      prefecture: '東京都',
      address: '東京都港区六本木7-15-13 六本木ダイヤハイツ1009',
      phone: '080-4853-1412',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/bb50b3d4b5ab0d35d6bbba9a75b30b9d.jfif',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/kr/slnH000555431/'
    },
    {
      id: 3,
      name: 'アルファクリック',
      region: '関東',
      prefecture: '東京都',
      address: '東京都墨田区業平1-10-8 タイカビル1階',
      phone: '03-5608-8625',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/679f438ec08284e8ab2cba2c470aa3d7.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/slnH000114523/'
    },
    {
      id: 4,
      name: 'ルクリック ビート店',
      region: '関東',
      prefecture: '東京都',
      address: '東京都墨田区錦糸3-4-6 キノエネビル２Ｆ',
      phone: '03-3621-4043',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/de10eb294c8ffa7656723ab93ee512c5.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://park.le-clic.com/'
    },
    {
      id: 5,
      name: 'ルクリック エスパス店',
      region: '関東',
      prefecture: '東京都',
      address: '東京都墨田区東駒形3-19-11 遠藤ビル１Ｆ',
      phone: '03-5610-4755',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/3849a4c9bc86c483499b74577e621d0b.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/slnH000409016/'
    },
    {
      id: 6,
      name: 'ルクリック銀座店',
      region: '関東',
      prefecture: '東京都',
      address: '東京都中央区銀座5-10-9 銀座ＹＫビル２Ｆ',
      phone: '03-5568-1855',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/6bef6f3156e782285ef00dcef8bdf42a.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://fpg.le-clic.com/'
    },
    {
      id: 7,
      name: 'sugar.c',
      region: '関東',
      prefecture: '東京都',
      address: '東京都中央区月島3-14-8 1F',
      phone: '03-3520-8611',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/98bc61b23e7499a08543e24612aaa143.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/slnH000412973/'
    },
    {
      id: 8,
      name: 'hairterrace Bule Moon',
      region: '九州・沖縄',
      prefecture: '佐賀県',
      address: '佐賀県唐津市浜玉町浜崎1745',
      phone: '0955-56-6035',
      features: [],
      image: 'https://public.readdy.ai/ai/img_res/f886adf3713dc95f4441174e178eebc4.jpg',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://map.yahoo.co.jp/v3/place/FZUGn7wLg8s'
    },
    {
      id: 9,
      name: 'WOOD HEAL',
      region: '九州・沖縄',
      prefecture: '福岡県',
      address: '福岡県福岡市博多区博多駅南5-17-1 2F',
      phone: '092-481-6180',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/2b7a34f230595d7e3d02053d9295f952.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://woodheal.com/'
    },
    {
      id: 10,
      name: 'MIZ宝塚店',
      region: '関西',
      prefecture: '兵庫県',
      address: '兵庫県宝塚市売布東の町12-1',
      phone: '-',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/e70bdcb50397ecc28d9b48a1e7d0ce38.webp',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://miz-healthbeauty.com/'
    },
    {
      id: 11,
      name: 'MIZ武庫之荘店',
      region: '関西',
      prefecture: '兵庫県',
      address: '兵庫県尼崎市南武庫之荘 1-3-1 ドルチェ武庫之荘102号',
      phone: '-',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/2f0e9af6227cd36be988a76a406fecf6.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://miz-healthbeauty.com/'
    },
    {
      id: 12,
      name: 'エルマーナ',
      region: '中部',
      prefecture: '三重県',
      address: '三重県名張市南百合が丘116',
      phone: '0595-64-1270',
      features: [],
      image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20spa%20salon%20interior%20with%20elegant%20reception%20area%2C%20soft%20lighting%2C%20natural%20wood%20elements%2C%20comfortable%20seating%2C%20professional%20treatment%20rooms%2C%20zen%20atmosphere%2C%20high-end%20beauty%20salon%20design%20with%20plants%20and%20neutral%20colors&width=400&height=300&seq=salon-ermana&orientation=landscape',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: ''
    },
    {
      id: 13,
      name: 'GRAND JETE',
      region: '関西',
      prefecture: '大阪府',
      address: '大阪市中央区南船場4丁目9-7 日宝南船場キャトル４F',
      phone: '06-4708-7982',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/6347765948aaf0005b0db9d59d1eb522.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://grand-jete-totalbeauty.com/'
    },
    {
      id: 16,
      name: '小顎Café',
      region: '関西',
      prefecture: '大阪府',
      address: '大阪府大阪市中央区東心斎橋1-3-29 EAST心斎橋KMビル3F　美容室sage内',
      phone: '06-6245-3710',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/a0f75bfd844a1dacbc3a5f4cf262cd24.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://biyou-seikotsu.jp/shop/view/351'
    },
    {
      id: 17,
      name: '伝説のヘッドスパ 貝塚店',
      region: '関西',
      prefecture: '大阪府',
      address: '大阪府貝塚市近木町７−１４',
      phone: '090-9996-8319',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/36caba0ef1f1d2f3d539925e3934c650.png',
      businessHours: '営業時間はお問い合わせしてください',
      closedDays: '',
      link: 'https://www.densetsuhead.com/'
    },
    {
      id: 18,
      name: 'Venus',
      region: '関東',
      prefecture: '東京都',
      address: '東京都港区南青山5-10-2 第二九曜ビル3F',
      phone: '03-6427-2033',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/11b8516197fa0d5c6cf5072f2be09f6a.jpeg',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'http://venus-eri.com/'
    },
    {
      id: 20,
      name: 'センス大井町 ゼームス坂・本店',
      region: '関東',
      prefecture: '東京都',
      address: '東京都品川区南品川5-10-44 石村ビル',
      phone: '03-5479-6327',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/c6132d7011d0145960a6c9bdaf959efc.png',
      businessHours: '営業時間はお問い合わせください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/slnH000548102/'
    },
    {
      id: 21,
      name: 'rubato',
      region: '関東',
      prefecture: '東京都',
      address: '東京都中央区銀座2-11-8 ラウンドクロス銀座2丁目　4FC区画',
      phone: '090-7805-5567',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/f1166ead54f4850db983dad0371d9c2b.png',
      businessHours: '営業時間はお問い合わせしてください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/slnH000483589/'
    },
    {
      id: 22,
      name: 'ファビュラス',
      region: '関東',
      prefecture: '東京都',
      address: '東京都品川区東五反田5-24-8 YMビル7F',
      phone: '03-6884-7606',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/752c79f2186066f64e5602a9b448d349.png',
      businessHours: '営業時間はお問い合わせしてください',
      closedDays: '',
      link: 'https://map.yahoo.co.jp/v3/place/vCAPPy0VALY'
    },
    {
      id: 23,
      name: 'Aeolus 相模大野店',
      region: '関東',
      prefecture: '神奈川県',
      address: '神奈川県相模原市南区相駒大野3-16-7 MATビル1F',
      phone: '042-765-6880',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/8b2dc68231c1562390fedbb56940130e.png',
      businessHours: '営業時間はお問い合わせしてください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/slnH000040488/'
    },
    {
      id: 24,
      name: 'Aeolus Lana 相模大野店',
      region: '関東',
      prefecture: '神奈川県',
      address: '神奈川県相模原市南区相駒大野5-27-4-1F',
      phone: '042-705-2773',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/cc2534afe99fe60cfa030fdfb481bf73.png',
      businessHours: '営業時間はお問い合わせしてください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/slnH000462539/'
    },
    {
      id: 25,
      name: "fierte'",
      region: '関西',
      prefecture: '大阪府',
      address: '大阪府枚方市大垣内町２丁目１６-２藤田ビル 2F',
      phone: '072-841-6006',
      features: [],
      image: 'https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/e4b0b9c19bb382db70a63c0d3e66cd51.png',
      businessHours: '営業時間はお問い合わせしてください',
      closedDays: '',
      link: 'https://beauty.hotpepper.jp/slnH000360926/'
    }
  ];

  const filteredSalons = salons.filter(salon => {
    const regionMatch = selectedRegion === '全国' || salon.region === selectedRegion;
    const searchMatch = searchTerm === '' ||
      salon.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      salon.prefecture.toLowerCase().includes(searchTerm.toLowerCase()) ||
      salon.address.toLowerCase().includes(searchTerm.toLowerCase());
    return regionMatch && searchMatch;
  });

  const handleAffiliateFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new FormData();
      Object.entries(affiliateFormData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d35on0m78msbhm7e6s70', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setAffiliateFormData({ salon_name: '', representative_name: '', email: '', phone: '', address: '', experience_years: '', staff_count: '', message: '' });
        setTimeout(() => {
          // サロン様専用サイトに遷移
          window.open('https://densetsu-headspa-crik922.gamma.site/', '_blank');
          setShowAffiliateForm(false);
          setSubmitStatus('idle');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "伝説のヘッドスパ 全国加盟サロン一覧",
    "description": "全国各地で同じ品質のヘッドスパ体験をご提供する加盟サロンの一覧です。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/salons`,
    "numberOfItems": salons.length,
    "itemListElement": salons.map((salon, index) => ({
      "@type": "LocalBusiness",
      "position": index + 1,
      "name": salon.name,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": salon.address,
        "addressRegion": salon.prefecture,
        "addressCountry": "JP"
      },
      "telephone": salon.phone,
      "openingHours": salon.businessHours,
      "description": `${salon.features.length > 0 ? salon.features.join('、') + 'などの特徴があるヘッドスパサロンです。' : 'ヘッドスパサロンです。'}`
    }))
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SEOHead
        title="全国の加盟サロン | 伝説のヘッドスパ"
        description="全国各地で同じ品質のヘッドスパ体験をご提供しております。お近くのサロンでぜひ特別なケアをお受けください。"
        keywords="ヘッドスパサロン,全国,加盟店,サロン一覧,頭皮ケア,リラクゼーション"
        ogTitle="全国の加盟サロン | 伝説のヘッドスパ"
        ogDescription="全国各地で同じ品質のヘッドスパ体験をご提供しております。お近くのサロンでぜひ特別なケアをお受けください。"
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/salons`}
        schema={schema}
      />
      {/* ヘッダー */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              伝説のヘッドスパ
            </h1>
            <button 
              onClick={() => window.history.back()}
              className="flex items-center text-amber-600 hover:text-amber-700 font-semibold cursor-pointer text-sm sm:text-base"
            >
              <i className="ri-arrow-left-line mr-1 sm:mr-2"></i>
              戻る
            </button>
          </div>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        {/* タイトルセクション */}
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            全国の加盟サロン
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-2">
            全国各地で同じ品質のヘッドスパ体験をご提供しております。
            お近くのサロンでぜひ特別なケアをお受けください。
          </p>
        </div>

        {/* 検索・フィルター */}
        <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 mb-6 sm:mb-8">
          <div className="grid lg:grid-cols-2 gap-4 sm:gap-6">
            {/* 地域選択 */}
            <div>
              <label className="block text-gray-700 font-semibold mb-2 sm:mb-3 text-sm sm:text-base">地域で絞り込み</label>
              <div className="flex flex-wrap gap-2">
                {regions.map((region) => (
                  <button
                    key={region}
                    onClick={() => setSelectedRegion(region)}
                    className={`px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                      selectedRegion === region
                        ? 'bg-amber-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {region}
                  </button>
                ))}
              </div>
            </div>

            {/* キーワード検索 */}
            <div>
              <label className="block text-gray-700 font-semibold mb-2 sm:mb-3 text-sm sm:text-base">キーワード検索</label>
              <div className="relative">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="サロン名、都道府県、住所で検索"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 pl-8 sm:pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                />
                <i className="ri-search-line absolute left-2 sm:left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              </div>
            </div>
          </div>
        </div>

        {/* 結果表示 */}
        <div className="mb-4 sm:mb-6">
          <p className="text-gray-600 text-sm sm:text-base">
            <span className="font-semibold text-amber-600">{filteredSalons.length}</span>
            件のサロンが見つかりました
          </p>
        </div>

        {/* サロン一覧 */}
        <div className="grid xl:grid-cols-2 gap-6 sm:gap-8">
          {filteredSalons.map((salon) => (
            <div key={salon.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="lg:flex">
                <div className="lg:w-1/3">
                  <img
                    src={salon.image}
                    alt={salon.name}
                    className="w-full h-48 lg:h-full object-cover object-top"
                  />
                </div>
                <div className="lg:w-2/3 p-4 sm:p-6">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 pr-2">{salon.name}</h3>
                    <span className="px-2 sm:px-3 py-1 bg-amber-100 text-amber-800 text-xs font-medium rounded-full whitespace-nowrap">
                      {salon.prefecture}
                    </span>
                  </div>

                  <div className="space-y-2 sm:space-y-3 mb-3 sm:mb-4">
                    <div className="flex items-start">
                      <i className="ri-map-pin-line text-amber-600 mr-2 mt-1 flex-shrink-0 text-sm"></i>
                      <p className="text-gray-600 text-xs sm:text-sm">{salon.address}</p>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-phone-line text-amber-600 mr-2 flex-shrink-0 text-sm"></i>
                      <p className="text-gray-600 text-xs sm:text-sm">{salon.phone}</p>
                    </div>
                    <div className="flex items-start">
                      <i className="ri-time-line text-amber-600 mr-2 mt-1 flex-shrink-0 text-sm"></i>
                      <p className="text-gray-600 text-xs sm:text-sm">
                        {salon.closedDays ? `営業時間: ${salon.businessHours} / 定休日: ${salon.closedDays}` : salon.businessHours}
                      </p>
                    </div>
                  </div>

                  {/* 特徴タグ */}
                  {salon.features.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-3 sm:mb-4">
                      {salon.features.map((feature, index) => (
                        <span
                          key={index}
                          className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-md"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* アクションボタン */}
                  <div className="flex gap-2 sm:gap-3">
                    {salon.link && (
                      <button 
                        onClick={() => {
                          window.open(salon.link, '_blank');
                        }}
                        className="flex-1 bg-amber-600 hover:bg-amber-700 text-white px-3 sm:px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap text-xs sm:text-sm"
                      >
                        <i className="ri-external-link-line mr-1"></i>
                        サロンリンク
                      </button>
                    )}
                  </div>

                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 検索結果が0件の場合 */}
        {filteredSalons.length === 0 && (
          <div className="text-center py-8 sm:py-12">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-search-line text-gray-400 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
              該当するサロンが見つかりませんでした
            </h3>
            <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">
              検索条件を変更してもう一度お試しください
            </p>
            <button
              onClick={() => {
                setSelectedRegion('全国');
                setSearchTerm('');
              }}
              className="bg-amber-600 hover:bg-amber-700 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base"
            >
              検索条件をリセット
            </button>
          </div>
        )}

        {/* お問い合わせセクション */}
        <div className="mt-12 sm:mt-16 bg-white rounded-lg shadow-lg p-6 sm:p-8 text-center">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
            新規加盟希望の場合
          </h3>
          <p className="text-gray-600 mb-4 sm:mb-6 max-w-2xl mx-auto text-sm sm:text-base">
            新規パートナーシップをご希望の方は
            お気軽にお問い合わせください。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <button 
              onClick={() => setShowAffiliateForm(true)}
              className="bg-amber-600 hover:bg-amber-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </div>
        </div>

        {/* フッター */}
        <footer className="bg-gray-900 text-white py-6 sm:py-8 mt-8 sm:mt-12 rounded-lg">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex flex-col sm:flex-row justify-between items-center">
              <p className="text-gray-400 mb-3 sm:mb-0 text-xs sm:text-sm">
                &copy; 2024 伝説のヘッドスパ. All rights reserved.
              </p>
              <div className="flex items-center gap-4 sm:gap-6">
                <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-400 transition-colors text-xs sm:text-sm cursor-pointer">
                  Made with Readdy
                </a>
                <button
                  onClick={() => setShowAffiliateForm(true)}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-xs sm:text-sm cursor-pointer flex items-center"
                >
                  <i className="ri-store-line mr-1"></i>
                  お問い合わせ
                </button>
              </div>
            </div>
          </div>
        </footer>

        {/* サロン加盟希望フォームモーダル */}
        {showAffiliateForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
              <div className="p-4 sm:p-6">
                <div className="flex items-center justify-between mb-4 sm:mb-6">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900">お問い合わせ</h3>
                  <button
                    onClick={() => setShowAffiliateForm(false)}
                    className="text-gray-400 hover:text-gray-600 cursor-pointer"
                  >
                    <i className="ri-close-line text-xl sm:text-2xl"></i>
                  </button>
                </div>

                <form id="affiliate-form" data-readdy-form onSubmit={handleAffiliateFormSubmit} className="space-y-3 sm:space-y-4">
                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">サロン名 *</label>
                    <input
                      type="text"
                      name="salon_name"
                      value={affiliateFormData.salon_name}
                      onChange={(e) => setAffiliateFormData({...affiliateFormData, salon_name: e.target.value})}
                      required
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">代表者名 *</label>
                    <input
                      type="text"
                      name="representative_name"
                      value={affiliateFormData.representative_name}
                      onChange={(e) => setAffiliateFormData({...affiliateFormData, representative_name: e.target.value})}
                      required
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">メールアドレス *</label>
                    <input
                      type="email"
                      name="email"
                      value={affiliateFormData.email}
                      onChange={(e) => setAffiliateFormData({...affiliateFormData, email: e.target.value})}
                      required
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">電話番号 *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={affiliateFormData.phone}
                      onChange={(e) => setAffiliateFormData({...affiliateFormData, phone: e.target.value})}
                      required
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">住所 *</label>
                    <input
                      type="text"
                      name="address"
                      value={affiliateFormData.address}
                      onChange={(e) => setAffiliateFormData({...affiliateFormData, address: e.target.value})}
                      required
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">営業年数</label>
                    <div className="relative">
                      <select
                        name="experience_years"
                        value={affiliateFormData.experience_years}
                        onChange={(e) => setAffiliateFormData({...affiliateFormData, experience_years: e.target.value})}
                        className="w-full px-3 sm:px-4 py-2 sm:py-3 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base appearance-none cursor-pointer"
                      >
                        <option value="">選択してください</option>
                        <option value="1年未満">1年未満</option>
                        <option value="1-3年">1-3年</option>
                        <option value="3-5年">3-5年</option>
                        <option value="5-10年">5-10年</option>
                        <option value="10年以上">10年以上</option>
                      </select>
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                        <i className="ri-arrow-down-s-line text-gray-400"></i>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">スタッフ数</label>
                    <div className="relative">
                      <select
                        name="staff_count"
                        value={affiliateFormData.staff_count}
                        onChange={(e) => setAffiliateFormData({...affiliateFormData, staff_count: e.target.value})}
                        className="w-full px-3 sm:px-4 py-2 sm:py-3 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base appearance-none cursor-pointer"
                      >
                        <option value="">選択してください</option>
                        <option value="1名">1名</option>
                        <option value="2-3名">2-3名</option>
                        <option value="4-5名">4-5名</option>
                        <option value="6-10名">6-10名</option>
                        <option value="10名以上">10名以上</option>
                      </select>
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                        <i className="ri-arrow-down-s-line text-gray-400"></i>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">メッセージ</label>
                    <textarea
                      name="message"
                      value={affiliateFormData.message}
                      onChange={(e) => setAffiliateFormData({...affiliateFormData, message: e.target.value})}
                      placeholder="ご質問やご要望など、自由にご記入ください"
                      rows={4}
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                    ></textarea>
                  </div>

                  {submitStatus === 'success' && (
                    <div className="p-3 sm:p-4 bg-green-50 text-green-700 rounded-lg text-sm sm:text-base">
                      お問い合わせを送信しました。ありがとうございます。
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="p-3 sm:p-4 bg-red-50 text-red-700 rounded-lg text-sm sm:text-base">
                      送信に失敗しました。時間をおいて再度お試しください。
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full py-2 sm:py-3 px-4 rounded-lg font-semibold text-white transition-colors text-sm sm:text-base ${
                      isSubmitting 
                        ? 'bg-gray-400 cursor-not-allowed' 
                        : 'bg-amber-600 hover:bg-amber-700 cursor-pointer'
                    }`}
                  >
                    {isSubmitting ? '送信中...' : '送信'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
